var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaInstances(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic instances",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M111.046 48.1212H22.9538C16.0008 48.1212 10.3691 42.4895 10.3691 35.5365V22.9518C10.3691 15.9988 16.0008 10.3672 22.9538 10.3672H111.046C117.999 10.3672 123.631 15.9988 123.631 22.9518V35.5365C123.631 42.4895 117.999 48.1212 111.046 48.1212Z",
    fill: "url(#paint0_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M111.046 85.879H22.9538C16.0008 85.879 10.3691 80.2473 10.3691 73.2943V60.7097C10.3691 53.7566 16.0008 48.125 22.9538 48.125H111.046C117.999 48.125 123.631 53.7566 123.631 60.7097V73.2943C123.631 80.2473 117.999 85.879 111.046 85.879Z",
    fill: "url(#paint1_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M111.046 123.629H22.9538C16.0008 123.629 10.3691 117.997 10.3691 111.044V98.4597C10.3691 91.5066 16.0008 85.875 22.9538 85.875H111.046C117.999 85.875 123.631 91.5066 123.631 98.4597V111.044C123.631 117.997 117.999 123.629 111.046 123.629Z",
    fill: "url(#paint2_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.2924 35.5378H35.5384C32.0588 35.5378 29.2461 32.7188 29.2461 29.2455C29.2461 25.7721 32.0588 22.9531 35.5384 22.9531H73.2924C76.772 22.9531 79.5847 25.7721 79.5847 29.2455C79.5847 32.7188 76.772 35.5378 73.2924 35.5378Z",
    fill: "url(#paint3_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M98.4623 35.5378C101.937 35.5378 104.755 32.7206 104.755 29.2455C104.755 25.7703 101.937 22.9531 98.4623 22.9531C94.9871 22.9531 92.1699 25.7703 92.1699 29.2455C92.1699 32.7206 94.9871 35.5378 98.4623 35.5378Z",
    fill: "url(#paint4_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M73.2924 73.2878H35.5384C32.0588 73.2878 29.2461 70.4688 29.2461 66.9955C29.2461 63.5221 32.0588 60.7031 35.5384 60.7031H73.2924C76.772 60.7031 79.5847 63.5221 79.5847 66.9955C79.5847 70.4688 76.772 73.2878 73.2924 73.2878Z",
    fill: "url(#paint5_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M98.4623 73.2878C101.937 73.2878 104.755 70.4706 104.755 66.9955C104.755 63.5203 101.937 60.7031 98.4623 60.7031C94.9871 60.7031 92.1699 63.5203 92.1699 66.9955C92.1699 70.4706 94.9871 73.2878 98.4623 73.2878Z",
    fill: "url(#paint6_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.2924 111.046H35.5384C32.0588 111.046 29.2461 108.227 29.2461 104.753C29.2461 101.28 32.0588 98.4609 35.5384 98.4609H73.2924C76.772 98.4609 79.5847 101.28 79.5847 104.753C79.5847 108.227 76.772 111.046 73.2924 111.046Z",
    fill: "url(#paint7_linear_9146_76286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M98.4623 111.046C101.937 111.046 104.755 108.228 104.755 104.753C104.755 101.278 101.937 98.4609 98.4623 98.4609C94.9871 98.4609 92.1699 101.278 92.1699 104.753C92.1699 108.228 94.9871 111.046 98.4623 111.046Z",
    fill: "url(#paint8_linear_9146_76286)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76286",
    x1: -51.5474,
    y1: 17.0419,
    x2: -16.2823,
    y2: 106.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_76286",
    x1: -51.5474,
    y1: 54.7997,
    x2: -16.2823,
    y2: 143.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9146_76286",
    x1: -51.5474,
    y1: 92.5497,
    x2: -16.2823,
    y2: 181.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9146_76286",
    x1: 54.4154,
    y1: 22.9531,
    x2: 54.4154,
    y2: 35.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9146_76286",
    x1: 98.4623,
    y1: 22.9531,
    x2: 98.4623,
    y2: 35.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9146_76286",
    x1: 54.4154,
    y1: 60.7031,
    x2: 54.4154,
    y2: 73.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9146_76286",
    x1: 98.4623,
    y1: 60.7031,
    x2: 98.4623,
    y2: 73.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9146_76286",
    x1: 54.4154,
    y1: 98.4609,
    x2: 54.4154,
    y2: 111.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9146_76286",
    x1: 98.4623,
    y1: 98.4609,
    x2: 98.4623,
    y2: 111.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaInstances);
export default __webpack_public_path__ + "static/media/figma-instances.5c42d87939a83668f52cef431379ccc8.svg";
export { ForwardRef as ReactComponent };